// Electric Resistivity units with conversion factors to ohm-meter (Ω·m)
export const electricResistivityUnits = [
  { id: 'ohm-meter', name: 'Ohm-Meter', symbol: 'Ω·m', plural: 'Ohm-Meters', toBase: 1 },
  { id: 'ohm-centimeter', name: 'Ohm-Centimeter', symbol: 'Ω·cm', plural: 'Ohm-Centimeters', toBase: 0.01 },
  { id: 'ohm-inch', name: 'Ohm-Inch', symbol: 'Ω·in', plural: 'Ohm-Inches', toBase: 0.0254 },
  { id: 'microhm-meter', name: 'Microhm-Meter', symbol: 'μΩ·m', plural: 'Microhm-Meters', toBase: 1e-6 },
  { id: 'microhm-centimeter', name: 'Microhm-Centimeter', symbol: 'μΩ·cm', plural: 'Microhm-Centimeters', toBase: 1e-8 },
  { id: 'abohm-centimeter', name: 'Abohm-Centimeter', symbol: 'abΩ·cm', plural: 'Abohm-Centimeters', toBase: 1e-11 },
  { id: 'statohm-centimeter', name: 'Statohm-Centimeter', symbol: 'statΩ·cm', plural: 'Statohm-Centimeters', toBase: 8.987551787e11 },
  { id: 'circular-mil-ohm-per-foot', name: 'Circular Mil Ohm/Foot', symbol: 'cmil·Ω/ft', plural: 'Circular Mil Ohms/Foot', toBase: 1.662426113e-9 },
];

export const popularElectricResistivityConversions = [
  { from: 'ohm-meter', to: 'ohm-centimeter' },
  { from: 'ohm-centimeter', to: 'ohm-meter' },
  { from: 'ohm-meter', to: 'microhm-centimeter' },
  { from: 'microhm-centimeter', to: 'ohm-centimeter' },
  { from: 'ohm-inch', to: 'ohm-centimeter' },
  { from: 'circular-mil-ohm-per-foot', to: 'ohm-meter' },
];

export const getUnitById = (id) => electricResistivityUnits.find(unit => unit.id === id);

export const convertElectricResistivity = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.toBase;
  return baseValue / toUnit.toBase;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert electric resistivity units and learn the conversion formula.`;
};
